import { useAppSelector } from 'store/store-hooks';
import { ModalEnum } from 'components/app/_mediator/app.slice';
import { usePickerContext } from './picker.provider';

import { ReactComponent as GooglePhotosIcon } from 'assets/social/google-photos.svg';
import { Modal } from 'components/UI/modal/modal';
import { AppButton } from 'components/app/app-components/app-button/app-button';
import styles from './_picker.module.scss';

export const PickerGoogle__open = () => {
  const modal = useAppSelector((state) => state.app.modal);
  const { gpReLogin, gpOpen, closeModal } = usePickerContext();

  return (
    <Modal className={styles.GPickerModal} isOpen={modal === ModalEnum.gpOpen} onRequestClose={closeModal}>
      <GooglePhotosIcon />
      <h3>Google Photos</h3>
      <footer>
        <AppButton onClick={() => gpReLogin()} outlined tip="Switch to a different Google account" tipPosition="bottom">
          Switch Accounts
        </AppButton>
        <AppButton onClick={gpOpen} tip="Open Google Photos window to choose files" tipPosition="bottom">
          Open Picker
        </AppButton>
      </footer>
    </Modal>
  );
};

export const PickerGoogle__submit = () => {
  const modal = useAppSelector((state) => state.app.modal);
  const { gpSubmit, closeModal } = usePickerContext();
  return (
    <Modal className={styles.GPickerModal} isOpen={modal === ModalEnum.gpSubmit} onRequestClose={closeModal}>
      <GooglePhotosIcon />
      <h3>Upload selected files</h3>
      <footer>
        <AppButton onClick={closeModal} outlined>
          No
        </AppButton>
        <AppButton onClick={gpSubmit}>Yes</AppButton>
      </footer>
    </Modal>
  );
};
